import { useEffect, useRef, useState } from 'react';
import circleBg3Img from '@/assets/image/circle-bg-3.png';

import { Canvas2DViewer } from '../body-2d-viewer/viewer';
import cx from './index.module.scss';

export interface BodyDetection2DViewerProp {
  part: Service.BodyPart;
  points: Palpation.PointTypeWithDirection[];
  imgUrl: string;
  onImageLoaded?: VoidFunc;
}

const BodyDetection2DViewer: React.FC<BodyDetection2DViewerProp> = ({ imgUrl, part, points, onImageLoaded }) => {
  const viewerRef = useRef<Canvas2DViewer>(undefined);
  const containerRef = useRef<any>();
  const [forceUpdatePoints, setForceUpdatePoints] = useState({});

  const initViewer = async () => {
    const viewer = new Canvas2DViewer({
      customCircleBgImg: circleBg3Img,
      containerId: 'canvas-detection-2d-viewer',
      containerWidth: containerRef.current.offsetWidth,
      containerHeight: containerRef.current.offsetHeight,
      imgUrl,
      pointArr: [],
      onImageLoaded: () => {
        setForceUpdatePoints({});
        onImageLoaded?.();
      },
    });

    await viewer.init();

    viewerRef.current = viewer;

    updatePoints(points);
  };

  const updatePoints = (points: Palpation.PointTypeWithDirection[]) => {
    viewerRef.current.updatePoints({
      points,
      isSmall: true,
    });
  };

  useEffect(() => {
    part && initViewer();
    return () => {
      viewerRef.current?.destroy();
      viewerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl, part]);

  useEffect(() => {
    if (viewerRef.current) {
      viewerRef.current.updatePoints({
        points,
        isSmall: true,
      });
    }
  }, [points, forceUpdatePoints]);

  return (
    <>
      <div ref={containerRef} id="canvas-detection-2d-viewer" className={cx('detection-canvas-viewer')}></div>
    </>
  );
};

export default BodyDetection2DViewer;
